export enum SchoolEnum {
    NEAREST = 'ng',
    VISITED = 'bes'
}